import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import Multiselect from "multiselect-react-dropdown";
import {
  AddCardOutlined,
  AddCircle,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor

function Add(props) {
  const [isEdit, setisEdit] = useState(false);
  const [isValidImage, setisValidImage] = useState(false);
  const [isValidDoc, setisValidDoc] = useState(false);
  const dispatch = useDispatch();
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [pinCodeDetails, setPinCodeDetails] = useState(null);
  const [isDocDragging, setIsDocDragging] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [bankVerfiyJson, setBankVerfiyJson] = useState("");
  const [bankVerificationDone, setBankVerificationDone] = useState(false);
  const [banks, setBanks] = useState([]);
  const [securityChequeImages, setSecurityChequeImages] = useState([]);
  const [isSalesPersonsValid, setIsSalesPersonsValid] = useState(true);
  const [isZonesValid, setIsZonesValid] = useState(true);
  let isAvailableImgAppended = false;
  const [verifiedBankDetails, setVerifiedBankDetails] = useState({
    accountNumber: "",
    ifscCode: "",
  });
  const [bankErrors, setBankErrors] = useState({
    accountNumber: "",
    ifscCode: "",
    bankName: "",
  });

  let vendorType = "";
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";
  const [formData, setFormData] = useState({
    mobileNo: "",
    godownName: "",
    city: "",
    state: "",
    pinCode: "",
    district: "",
    address: "",
  });
  const codeLabelMap = {
    distributor: "Distributor Code",
    dealer: "Dealer Code",
    retailer: "Retailer Code",
    "key-accounts": "Key Accounts Code",
    pro: "PRO Code",
  };

  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [salesPersons, setSalesPersons] = useState([]);
  const [typeCode, setTypeCode] = useState([]);
  const [priceList, setPriceList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [emergencyContactError, setEmergencyContactError] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  const [dynamicFields, setDynamicFields] = useState([
    { product: "", currency: "", mrp: "", discountedPrice: "", qty: "" },
  ]);

  useEffect(() => {
    getProductList();
  }, []);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const getProductList = () => {
    utils
      .callAPI("get", `/Product/product-price`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setProductList(res);
        } else {
          setProductList([]);
        }
      })
      .catch((err) => {
        setProductList([]);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    if (name === "mobileNo") {
      validatedValue = value.replace(/\D/g, "");
      setEmergencyContactError(validatedValue.length !== 10);
    }
    if (name === "paymentTerms" && value !== "None of Above") {
      setFormData({
        ...formData,
        customPaymentTerm: "",
      });
    }

    if (
      name === "accountNumber" ||
      name === "ifscCode" ||
      name === "bankName"
    ) {
      setBankVerificationDone(
        value === verifiedBankDetails[name] &&
          formData.accountNumber === verifiedBankDetails.accountNumber &&
          formData.ifscCode === verifiedBankDetails.ifscCode
      );
      // Clear the error message when the field is modified
      setBankErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();
      if (isEdit) {
        bodyFormData.append("id", props?.rowData?.id);
        bodyFormData.append("client_id", userProfile?.employeeId);
      }
      bodyFormData.append("contact_person_name", formData.authPersonName);
      bodyFormData.append("contact_mobile_no", formData.mobileNo);
      bodyFormData.append("godown_address", formData.address);
      bodyFormData.append("godown_state", formData.state);
      bodyFormData.append("godown_district", formData.district);
      bodyFormData.append("godown_city", formData.city);
      bodyFormData.append("godown_pincode", formData.pinCode);
      bodyFormData.append("dealership_id", props?.id);

      bodyFormData.append("godown_name", formData.godownName);

      utils
        .callAPI("post", "/sales/save_godown", bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const fetchPinCodeDetails = async (pinCode) => {
    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${pinCode}`
      );
      const data = await response.json();
      if (data && data.length > 0 && data[0].Status === "Success") {
        setPinCodeDetails(data[0].PostOffice[0]);
      } else {
        setPinCodeDetails(null);
      }
    } catch (error) {
      console.error("Error fetching pin code details:", error);
      setPinCodeDetails(null);
    }
  };

  useEffect(() => {
    if (formData.pinCode?.length === 6) {
      fetchPinCodeDetails(formData.pinCode);
    } else {
      setPinCodeDetails(null);
    }
  }, [formData.pinCode]);

  useEffect(() => {
    if (pinCodeDetails) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        city: pinCodeDetails.District,
        state: pinCodeDetails.State,
        country: pinCodeDetails.Country,
      }));
      setIsEditable(false); // Fields are filled correctly, keep them read-only
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        city: "",
        state: "",
        country: "",
      }));
      setIsEditable(true); // Enable manual entr
    }
  }, [pinCodeDetails]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setisEdit(true);

      setFormData({
        mobileNo: props?.rowData?.contact_mobile_no || "",
        address: props?.rowData?.godown_address || "",
        city: props?.rowData?.godown_city || "",
        godownName: props?.rowData?.godown_name || "",
        district: props?.rowData?.godown_district || "",
        pinCode: props?.rowData?.godown_pincode || "",
        state: props?.rowData?.godown_state || "",
        authPersonName: props?.rowData?.contact_person_name || "",
      });
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  const getBankList = () => {
    utils
      .callAPI("get", `/sales/getbankList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setBanks(res);
        } else {
          setBanks([]);
        }
      })
      .catch((err) => {
        setBanks([]);
      });
  };

  const getSalesPersonList = () => {
    utils
      .callAPI("get", `/sales/getSalesPersonList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setSalesPersons(res);
        } else {
          setSalesPersons([]);
        }
      })
      .catch((err) => {
        setSalesPersons([]);
      });
  };

  useEffect(() => {
    getBankList();
    getSalesPersonList();
  }, []);

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          {/* <h4>{isEdit ? `Edit ${vendorType}` : `Add ${vendorType}`}</h4> */}
          <h4>{isEdit ? `Edit Godown` : `Add Godown`}</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <h6>Contact Details</h6>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Contact Person Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Contact Person Name"
                      name="authPersonName"
                      value={formData.authPersonName}
                      onChange={handleInputChange}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Mobile No"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Mobile No"
                      name="mobileNo"
                      value={formData.mobileNo}
                      onChange={handleInputChange}
                      required
                      maxLength={10}
                    />
                    {emergencyContactError ? (
                      <span className="text-danger">
                        {" "}
                        Please provide a valid Mobile Number.
                      </span>
                    ) : (
                      ""
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <h6>Godown</h6>

            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Godown Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Godown Name"
                      name="godownName"
                      value={formData.godownName}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Address"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Address "
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Pin Code"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Pin Code "
                      name="pinCode"
                      value={formData.pinCode}
                      onChange={handleInputChange}
                      maxLength={6}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="City"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter City"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      readOnly={!isEditable}
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="State"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter State"
                      name="state"
                      value={formData.state}
                      onChange={handleInputChange}
                      maxLength={32}
                      readOnly={!isEditable}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="District"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter District"
                      name="district"
                      value={formData.district}
                      onChange={handleInputChange}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
